export default __webpack_public_path__ + "static/media/orange.fffb4a9d.jpg";